import WsProvider from './provider/WSProvider'

var base64 = require('base64_js');
var userDataKader = localStorage.getItem("userDataKader") ? JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader")))) : "";

var serviceName = "index";
var musteriService = {
    imageUrlBuyuk: WsProvider.resim + "/" + userDataKader["firmaKodu"] + "/buyuk/",
    imageUrlOrta: WsProvider.resim + "/" + userDataKader["firmaKodu"] + "/orta/",
    imageUrlKucuk: WsProvider.resim + "/" + userDataKader["firmaKodu"] + "/kucuk/",
    imageUrlEnKucuk: WsProvider.resim + "/" + userDataKader["firmaKodu"] + "/enkucuk/",
    path  : "https://www.kaderfood.ch/",
    uyeOl(adSoyad,telefon,dogumTarihi,mail,sifre) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                adSoyad: adSoyad,
                telefon: telefon,
                dogumTarihi: dogumTarihi,
                mail: mail,
                sifre: sifre,
                serviceName: "musteri",
                methodName: "uyeOl"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    login(mail, sifre) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                mail: mail,
                sifre: sifre,
                serviceName: "musteri",
                methodName: "login"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    musteriListesi(durum,baslangic,limit) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                durum: durum,
                baslangic: baslangic,
                limit: limit,
                serviceName: "musteri",
                methodName: "musteriListesi"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    musteriDetay(musteriKodu) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                musteriKodu: musteriKodu,
                serviceName: "musteri",
                methodName: "musteriDetay"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    musteriDurumGuncelle(musteriKodu,durum) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                musteriKodu: musteriKodu,
                durum: durum,
                serviceName: "musteri",
                methodName: "musteriDurumGuncelle"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

    siparisListesi(baslangic,limit,durum) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                baslangic: baslangic,
                limit: limit,
                durum: durum,
                serviceName: "musteri",
                methodName: "siparisListesi"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

    siparisDetay(msiparisId) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                msiparisId: msiparisId,
                serviceName: "musteri",
                methodName: "siparisDetay"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

    musteriSiparisListesi(baslangic,limit,musteriKodu) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                baslangic: baslangic,
                limit: limit,
                musteriKodu: musteriKodu,
                serviceName: "musteri",
                methodName: "musteriSiparisListesi"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    siparisTanimlama(tur,adSoyad,telefon,urunList) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                tur: tur,
                adSoyad: adSoyad,
                telefon: telefon,
                urunList: urunList,
                serviceName: "musteri",
                methodName: "siparisTanimlama"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

    siparisOdemeGuncelle(msiparisId,odeme, odemeSekli) {
        var userDataKaderRestoran = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKaderRestoran"))));
        var param = {
            data: {
                yonetimId: userDataKaderRestoran["yonetimId"],
                userToken: userDataKaderRestoran["token"],
                firmaKodu: userDataKaderRestoran["firmaKodu"],
                msiparisId: msiparisId,
                odeme: odeme,
                odemeSekli: odemeSekli,
                serviceName: "musteri",
                methodName: "siparisOdemeGuncelle"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

    siparisCountDashboard() {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                serviceName: "musteri",
                methodName: "siparisCountDashboard"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

    siparisToplamDashboard() {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                serviceName: "musteri",
                methodName: "siparisToplamDashboard"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

    sonSiparisList(tur) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                tur: tur,
                serviceName: "musteri",
                methodName: "sonSiparisList"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

    siparisDurumGuncelle(msiparisId , durum, dakika) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                msiparisId : msiparisId ,
                durum: durum,
                dakika: dakika ? dakika : '',
                serviceName: "musteri",
                methodName: "siparisDurumGuncelle"
            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },

    siparisSearch(arama,durum) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                arama: arama,
                durum: durum,
                serviceName: "musteri",
                methodName: "musteriSiparisArama"
            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },

    siparisCount(durum) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                durum: durum,
                serviceName: "musteri",
                methodName: "siparisCount"
            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },
}

export default musteriService

